import "./src/styles/global.css"
import "./src/styles/reset.css"
import React from 'react';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs'
import "./config/amplifyConfig"

export const wrapRootElement = ({element}) => {
    return <LocalizationProvider dateAdapter={AdapterDayjs}>
            {element}
    </LocalizationProvider>
};